import { MDText } from 'i18n-react';

import SendCommunicationTexts from './texts.json';

export const T = new MDText(SendCommunicationTexts);
